import { useTranslation } from 'react-i18next'

import { Minus } from '../../assets/icons/Minus.tsx'
import { Plus } from '../../assets/icons/Plus.tsx'
import { IconButton } from '../IconButton'

interface InputQuantityProps {
  min?: number
  max?: number
  productName: string
  quantity: number
  quantityChange: (quantity: number) => void
}

export const InputQuantity = (props: InputQuantityProps) => {
  const { t } = useTranslation()
  const min = props.min ?? 0
  const max = props.max ?? Infinity

  const decrement = () => {
    props.quantityChange(Math.max(min, props.quantity - 1))
  }

  const increment = () => {
    props.quantityChange(Math.min(max, props.quantity + 1))
  }

  const quantityIsMin = props.quantity === 0 || min === props.quantity
  const quantityIsMax = !!props.max && props.quantity === props.max

  if (min === 0 && max === 0) {
    return t('extra.notAvailable')
  }

  if (min === max) {
    return <div>{t('extra.includedExtras', { value: props.quantity })}</div>
  }
  return (
    <div
      aria-label={t('a11y.quantitySelector', { name: props.productName })}
      className="flex items-center"
      role="group"
    >
      <IconButton
        ariaLabel={t('a11y.reduceQuantity')}
        icon={Minus}
        isDisabled={quantityIsMin}
        onClick={decrement}
      />
      <span
        aria-atomic="true"
        aria-live="polite"
        className="mx-4 text-sm font-bold leading-4"
      >
        {props.quantity}
      </span>
      <IconButton
        ariaLabel={t('a11y.increaseQuantity')}
        icon={Plus}
        isDisabled={quantityIsMax}
        onClick={increment}
      />
    </div>
  )
}
